import { useEffect, useState } from "react";

export function InstallNudge() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const ua = navigator.userAgent;
    const isIOS = /iPhone|iPad/.test(ua);
    const isStandalone = (navigator as any).standalone === true;
    const dismissed = localStorage.getItem("install-nudge-dismissed") === "1";
    if (isIOS && !isStandalone && !dismissed) setShow(true);
  }, []);

  if (!show) return null;

  return (
    <div className="fixed bottom-16 inset-x-2 bg-attic-accent text-white text-xs px-3 py-2 rounded-xl shadow flex items-center gap-2 z-40">
      <span>Tap ⎙ → "Add to Home Screen"</span>
      <button
        onClick={() => { localStorage.setItem("install-nudge-dismissed", "1"); setShow(false); }}
        className="ml-auto"
        aria-label="Dismiss"
      >✕</button>
    </div>
  );
}
